export default __webpack_public_path__ + "assets/product-overview-video-1-thumbnail-new.png";